export const environment = {
    production: true,
    sshDialogData: {
        port: 22,
        password: '',
        host: '127.0.0.1',
        username: 'ft-user',
    }
};
